import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingComponent, TitleInformationComponent } from "../../components";
import { SelectOptionsContainer } from "../SelectOptionsContainer/SelectOptionsContainer";
import { getRetrieveBannerHistory } from "../../store/banner/history/thunks";
import { setRetrieveBannerHistory } from "../../store/banner/history/historySlice";

export const SettingLandingBannersHistoryInformationContainer = () => {
  const { bannerHistoryData, showLoading } = useSelector(
    (state) => state.retrieveBannerHistory
  );
  const dispatch = useDispatch();

  const newData = [
    {
      title: "Portada Desktop",
      name: "coverDesktop",
      value: bannerHistoryData?.coverDesktop?.url,
    },
    {
      title: "Portada Mobile",
      name: "coverMobile",
      value: bannerHistoryData?.coverMobile?.url,
    },
  ];

  useEffect(() => {
    dispatch(getRetrieveBannerHistory());
    // eslint-disable-next-line
  }, []);

  const handleOnChange = (e) => {
    const key = e.target.name;
    let value = e.target.value;
    const file = e.target.files[0];
    value = {
      url: URL.createObjectURL(file),
      type: file.type,
      name: file.name,
    };
    dispatch(setRetrieveBannerHistory({ data: { [key]: value } }));
  };

  const handleOnChangeArray = (e, index, data, name) => {
    let value = e.target.value;
    const file = e.target.files[0];
    value = {
      url: URL.createObjectURL(file),
      type: file.type,
      name: file.name,
    };
    const updatedData = {
      ...data[index],
      url: value.url,
      type: value.type,
      name: value.name,
    };
    const updateds = [
      ...data.slice(0, index),
      updatedData,
      ...data.slice(index + 1),
    ];
    dispatch(setRetrieveBannerHistory({ data: { [name]: updateds } }));
  };

  return (
    <div className="productDetailInformationContainer">
      {!showLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <TitleInformationComponent title={"Información General"} />
          {newData?.map(({ title, name, value }) => (
            <SelectOptionsContainer
              key={name}
              title={title}
              handleOnchange={handleOnChange}
              name={name}
              isImageEdit={true}
              value={value}
            />
          ))}
          {bannerHistoryData?.photos?.map((_, index) => (
            <SelectOptionsContainer
              key={`collage-${index}`}
              title={`Collage ${index + 1}`}
              handleOnchange={(e) =>
                handleOnChangeArray(
                  e,
                  index,
                  bannerHistoryData?.photos,
                  "photos"
                )
              }
              name={`imagen_${index + 1}`}
              isImageEdit={true}
              value={bannerHistoryData?.photos?.[index]?.url}
            />
          ))}
        </>
      )}
    </div>
  );
};
